/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { IconRender } from "@/components/shared/Icon-render";
import { format } from "date-fns";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import {
  /* Calendar, */ CheckIcon,
  /* Clock8, */ LoaderCircle,
} from "lucide-react";
import { SwitchRenderer } from "@/components/shared/switch-renderer";
import { cn, getSummary } from "@/lib/utils";
import { ViewMore } from "./view-more";
import { EmailSource } from "./email-source";

export const ReactTableCell = ({ header, value, row }: any) => {
  switch (header) {
    /* Erp Ref # */
    case "erp_info": {
      return (
        <div className="pt-1">
          {value?.sale_invoice_reference ||
          value?.sale_order_reference ||
          value?.sale_invoice_number ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="text-green-500 truncate w-full bg-green-50 py-1 text-center  border-green-100 border px-3  rounded-[50px] inline-block">
                  {value?.sale_invoice_reference ||
                    value?.sale_order_reference ||
                    value?.sale_invoice_number}
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <p>
                  {value?.sale_invoice_reference ||
                    value?.sale_order_reference ||
                    value?.sale_invoice_number}
                </p>
              </TooltipContent>
            </Tooltip>
          ) : (
            <span className="inline-block"></span>
          )}
          {/* {value?.cts ||
          value?.sale_invoice_reference ||
          value?.sale_order_reference ? (
            <ViewMore
              isViewMore={value?.cts ? true : false}
              header={
                <div className="flex flex-col">
                  {value?.sale_invoice_reference ||
                  value?.sale_order_reference ? (
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <span className="text-green-500 truncate bg-green-50 py-1 text-center  border-green-100 border px-3  rounded-[50px] inline-block">
                          {value?.sale_invoice_reference ||
                            value?.sale_order_reference}
                        </span>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>
                          {value?.sale_invoice_reference ||
                            value?.sale_order_reference}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  ) : (
                    <span className="inline-block"></span>
                  )}
                </div>
              }
            >
              <div className="flex flex-col">
                <span className="opacity-70">Pushed Date:</span>
                <span className="inline-block">
                  {format(value?.cts, "yyyy-MM-dd") || "-"}
                </span>
              </div>
            </ViewMore>
          ) : null} */}
        </div>
      );
    }
    case "uts": {
      const formattedDateTime = format(value, "dd-MM-yyyy hh:mm a"); // Format with date and time

      return <span className="truncate">{value ? formattedDateTime : ""}</span>;
    }
    case "sales_report_date": {
      const formattedDateTime = format(value, "dd-MM-yyyy"); // Format with date and time

      return <span className="truncate">{value ? formattedDateTime : ""}</span>;
    }
    case "erp_ref_number": {
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="truncate w-full  inline-block">{value}</span>
            </TooltipTrigger>
            <TooltipContent>{String(value).trim()}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    case "is_flagged": {
      const displayValue = () => {
        const getKey = Object.values(value.terminal_keys);
        if (Array.isArray(getKey)) {
          return getKey.join(", ");
        }
        if (typeof getKey === "string") {
          return getKey;
        }
        return JSON.stringify(getKey);
      };
      return (
        <>
          {value?.enabled ? (
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger>
                  <span className="border border-primary/50 w-7 text-[15px] h-auto aspect-square rounded-full flex items-center justify-center">
                    <CheckIcon size={15} className="text-primary" />
                  </span>
                </TooltipTrigger>
                <TooltipContent>{displayValue()}</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            <span className="border w-7 text-[15px] h-auto aspect-square rounded-full flex items-center justify-center">
              ?
            </span>
          )}
        </>
      );
    }
    case "erp_customer_info": {
      const isViewMore =
        value?.customer_id || value?.branch_name || value?.vendor_name;
      return (
        <div className="flex flex-col py-2">
          <ViewMore
            header={({ more }) =>
              value?.customer_id ? (
                <div className={cn(more ? "" : "truncate")}>
                  <strong className="">Customer Id: </strong>
                  <span className={cn("text-gray-600")}>
                    {value?.customer_id}
                  </span>
                </div>
              ) : null
            }
            isViewMore={isViewMore ? true : false}
          >
            <>
              {value?.branch_name ? (
                <div>
                  <strong>Branch name: </strong>
                  <span className="text-gray-600">{value?.branch_name}</span>
                </div>
              ) : null}
              {value?.vendor_name ? (
                <div>
                  <strong>Vendor name: </strong>
                  <span className="text-gray-600">{value?.vendor_name}</span>
                </div>
              ) : null}
            </>
          </ViewMore>
        </div>
      );
    }
    case "source_type": {
      return (
        <span className="flex items-center gap-1 border w-8 aspect-square rounded-full  justify-center">
          <SwitchRenderer
            type={value}
            components={{
              undefined,
              null: (
                <Tooltip>
                  <TooltipTrigger className="text-primary font-bold scale-125">
                    ?
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    Unknown Source
                  </TooltipContent>
                </Tooltip>
              ), // Maps both "success" and "winner" to Success
              upload: (
                <Tooltip>
                  <TooltipTrigger>
                    <IconRender
                      name="Upload"
                      size={15}
                      strokeWidth={2}
                      className=" text-primary"
                    />
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    Upload
                  </TooltipContent>
                </Tooltip>
              ),
              mail: <EmailSource archiveId={row?.originData?.archive_id} />,
              email: <EmailSource archiveId={row?.originData?.archive_id} />,
              default: (
                <Tooltip>
                  <TooltipTrigger className="text-primary font-bold scale-125">
                    ?
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    Unknown Source
                  </TooltipContent>
                </Tooltip>
              ), // Fallback component
            }}
          />
        </span>
      );
    }
    case "state": {
      return (
        <span className="uppercase">
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger>
                <>
                  <ConditionRenderer
                    condition={["pending", "void"].includes(value)}
                  >
                    <span className="text-orange-500 bg-orange-50 py-1 border-orange-100 border px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </ConditionRenderer>
                  <ConditionRenderer
                    condition={["snc_success"].includes(value)}
                  >
                    <span className="text-[#1268b3] bg-[#1268b326] py-1  border-[#1268b326] border px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </ConditionRenderer>
                  <ConditionRenderer
                    condition={[
                      "erp_success",
                      "success",
                      "processed",
                      "erp_processed",
                      "erp_success",
                    ].includes(value)}
                  >
                    <span className="text-green-500 bg-green-50 py-1  border-green-100 border px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </ConditionRenderer>
                  <ConditionRenderer
                    condition={[
                      "failed",
                      "erp_failed",
                      "validation_failed",
                    ].includes(value)}
                  >
                    <span className="text-red-500 bg-red-50 py-1 border border-red-100 px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </ConditionRenderer>
                  <ConditionRenderer
                    condition={["erp_initiated"].includes(value)}
                  >
                    <span className="text-purple-500 bg-purple-50 py-1 border border-purple-100 px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </ConditionRenderer>
                  <ConditionRenderer
                    condition={[
                      "on_hold",
                      "erp_hold",
                      "erp_pending",
                      "snc_pending",
                      "duplicate",
                    ].includes(value)}
                  >
                    <span className="text-orange-500 bg-orange-50 py-1 border border-orange-100 px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </ConditionRenderer>
                  <ConditionRenderer condition={["processing"].includes(value)}>
                    <span className="text-blue-500 py-1 items-center border border-blue-100 px-3  rounded-[50px] inline-flex gap-1">
                      <LoaderCircle className="animate-spin" size={15} />{" "}
                      {value}
                    </span>
                  </ConditionRenderer>
                  <ConditionRenderer
                    condition={["unsupported"].includes(value)}
                  >
                    <span className="text-gray-500 py-1 items-center border border-gray-200 px-3  rounded-[50px] inline-flex gap-1">
                      {value}
                    </span>
                  </ConditionRenderer>
                </>
              </TooltipTrigger>
              {row?.originData?.status_msg?.msg ? (
                <TooltipContent>
                  <TooltipArrow />
                  {row?.originData?.status_msg?.msg}
                </TooltipContent>
              ) : null}
            </Tooltip>
          </TooltipProvider>
        </span>
      );
    }
    /* Details */
    case "erp_status": {
      const list = getSummary(value);
      const erp_warnings = row?.originData?.erp_info?.warnings;

      const erp_warning_message =
        erp_warnings && erp_warnings?.length !== 0
          ? erp_warnings?.map((item: any) => item.warning)
          : null;

      return (
        <ul className=" flex flex-wrap list-disc">
          <TooltipProvider delayDuration={0}>
            {erp_warning_message ? (
              <Tooltip>
                <TooltipTrigger className="text-left">
                  <li className="capitalize">
                    <span className="truncate">Erp Warning</span>
                  </li>
                </TooltipTrigger>
                <TooltipContent>
                  <TooltipArrow />
                  <ul className="details-list">
                    {erp_warning_message.map(
                      (message: string, pIndex: number) => {
                        return <li key={pIndex}>{message}</li>;
                      },
                    )}
                  </ul>
                </TooltipContent>
              </Tooltip>
            ) : null}
            {Object.entries(list).map(([key, keyValue]: any, index) => {
              return (
                <Tooltip key={index}>
                  <TooltipTrigger className="text-left">
                    <li className="capitalize">
                      <span className="truncate">
                        {key.replaceAll("_", " ")}
                      </span>
                    </li>
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    <ul className="details-list">
                      {keyValue.map(
                        (
                          item: {
                            type: string;
                            message: string;
                            data?: string[];
                          },
                          pIndex: number,
                        ) => {
                          if (item.type === "string") {
                            return <li key={pIndex}>{item.message}</li>;
                          } else if (item.type === "array") {
                            return (
                              <li key={pIndex}>
                                {item.message}
                                <ul>
                                  {item?.data?.map(
                                    (data: string, index: number) => {
                                      return <li key={index}>{data}</li>;
                                    },
                                  )}
                                </ul>
                              </li>
                            );
                          }
                        },
                      )}
                    </ul>
                  </TooltipContent>
                </Tooltip>
              );
            })}
          </TooltipProvider>
        </ul>
      );
    }
    case "retailer_id": {
      return (
        <span className="uppercase">
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger className="truncate">
                {row?.originData?.retailer_name || value}
              </TooltipTrigger>
              <TooltipContent>
                {row?.originData?.retailer_name || value}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          {}
        </span>
      );
    }
    case "reference_number": {
      return (
        <span className="uppercase ">
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger className="truncate">
                <span className="select-none pointer-events-none">{value}</span>
              </TooltipTrigger>
              <TooltipContent
                className=""
                // onMouseUp={() => handleSelection(value)}
                onCopy={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(value);
                }}
              >
                {String(value).trim()}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          {}
        </span>
      );
    }
    case "transitions": {
      return (
        <>
          <ConditionRenderer condition={value?.[0]?.[0] && value?.length > 0}>
            <AlertDialog>
              <AlertDialogTrigger className=" flex break-words items-center gap-2 justify-between w-full text-left">
                <IconRender className="w-[50px]" name="Info" />
                <span className="truncate">
                  {value?.[value.length - 1]?.[0]}
                </span>
              </AlertDialogTrigger>
              <AlertDialogContent className="p-0  !min-w-max">
                <AlertDialogHeader>
                  <AlertDialogTitle className="px-4 pt-3 pb-1">
                    Transitions
                  </AlertDialogTitle>
                  <hr />
                  <AlertDialogDescription className="px-5 py-5 ">
                    <div className="max-h-[calc(100dvh-250px)] overflow-y-auto w-full rounded-md border ">
                      <table className="w-full">
                        <thead>
                          <tr className="text-slate-900 ">
                            <th className="border px-3 font-medium py-2 bg-gray-50 sticky top-0">
                              Task name
                            </th>
                            <th className="border px-3 py-2 font-medium bg-gray-50 sticky top-0">
                              Start time
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {value?.map((item: any, index: number) => {
                            return (
                              <tr key={index} className="text-slate-500">
                                <td className="border px-3 py-2">
                                  {item?.[0]}
                                </td>
                                <td className="border px-3 py-2">
                                  <div className="w-[170px]">
                                    {format(
                                      new Date(item?.[1]),
                                      "MMM do, yyyy	hh:mm a	",
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <hr />

                <AlertDialogFooter className="px-4 pb-3 pt-1">
                  <AlertDialogCancel>Cancel</AlertDialogCancel>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
          </ConditionRenderer>
          <ConditionRenderer condition={value?.[0]?.[0] && value?.length < 0}>
            <span className="flex items-center gap-1">{value?.[0]?.[0]}</span>
          </ConditionRenderer>
        </>
      );
    }
    case "file_path": {
      return (
        <Tooltip>
          <TooltipTrigger className="text-left break-words">
            {value}
          </TooltipTrigger>
          <TooltipContent>{value}</TooltipContent>
        </Tooltip>
      );
    }
    case "has_child": {
      return <span>{value ? "Yes" : "No"}</span>;
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
